import './Login.less';
import mainLogo from '../../assets/smartdrive_logo_light.svg';
import React, { Component } from 'react';
import { Layout, notification, AppLocaleProvider } from 'sd-ui-components';
import { observer, inject } from 'mobx-react';
import PageLoadLogger from '../../utils/PageLoadLogger';
import LoginForm from './LoginForm';
import UnauthenticatedFooter from '../AppLayout/UnauthenticatedFooter';
import history from '../../history';
import { useOidc } from '@axa-fr/react-oidc';

const { injectIntl } = AppLocaleProvider;
const { Header, Content } = Layout;

@inject('ConfigStore')
@inject('AuthStore')
@inject('NotificationsStore')
@observer
class Login extends Component {
  pageLoadLogger = new PageLoadLogger('Login');

  componentDidMount() {
    if (this.props.AuthStore.isAuthenticated) {
      const { isAuthenticated } = useOidc();
      if (!isAuthenticated) {
        this.props.history.replace(`/safety`);
      } else {
        sessionStorage.setItem('externalRedirect', false);
        history.replace(`/safetysecure`, '_self');
      }
    } else {
      this.props.AuthStore.initRememberMeFromStorage();
    }

    if (this.props.isLegacyAppRedirect) {
      this.showLegacyAppNotification();
    }
    this.pageLoadLogger.capture();
  }

  updateLoginInfo = (key, value) => {
    this.props.AuthStore.loginInfo[key] = value;
  };

  onChangeLoginInfo = event => {
    this.updateLoginInfo(event.target.name, event.target.value);
  };

  onChangeLoginInfoCheckbox = event => {
    this.updateLoginInfo(event.target.name, event.target.checked);
  };

  login = () => {
    this.props.AuthStore.login();
  };

  loginAuth0 = () => {
    this.props.AuthStore.loginAuth0();
  };

  toggleModal = () => {
    this.setState({
      helpModalVisible: !this.state.helpModalVisible
    });
  };

  componentWillUnmount = () => {
    this.props.NotificationsStore.clearNotifications();
  };

  showLegacyAppNotification() {
    notification['info']({
      placement: 'topRight',
      message: this.props.intl.formatMessage({
        id: 'App.Login.MovedNotification.Header',
        defaultMessage: `We've moved!`
      }),
      description: this.props.intl.formatMessage({
        id: 'App.Login.MovedNotification.Body',
        defaultMessage: `You've been redirected to our new login page. Please update your bookmarks.`
      }),
      duration: 1000 * 20 // 20 Seconds
    });
  }

  render() {
    return (
      <div className="login-root">
        <Layout className="login-layout">
          <Header className="login-header sd-branding-color-border sd-primary-background-color-2-fade">
            <img className="login-logo" src={mainLogo} alt="Smartdrive" />
          </Header>

          <Content className="login-content sd-primary-background-color-1-fade">
            <LoginForm />
          </Content>

          <UnauthenticatedFooter />
        </Layout>
      </div>
    );
  }
}

export default injectIntl(Login);



// WEBPACK FOOTER //
// ./src/containers/Login/Login.jsx